import { ATS_CONSTANTS } from '../constants';
import { Candidate } from '../types';
import { AtsAction } from '../utils/atsUtils';

export interface BulkAction {
  label: string;
  action: AtsAction;
}

export const useBulkActions = (
  selectedCandidates: Set<string>,
  findCandidate: (id: string) => { candidate: Candidate } | null
) => {
  const getBulkActions = (): BulkAction[] => {
    const selectedCandidatesList = Array.from(selectedCandidates)
      .map((id) => findCandidate(id)?.candidate)
      .filter((c): c is Candidate => !!c);

    if (selectedCandidatesList.length === 0) return [];

    const columns = selectedCandidatesList.map((cand) => cand.column);
    const uniqueColumns = Array.from(new Set(columns));

    if (uniqueColumns.length === 1) {
      const column = uniqueColumns[0];
      const actions: BulkAction[] = [];

      if (column === ATS_CONSTANTS.COLUMNS.APPLIED) {
        actions.push({ label: 'Schedule Interview', action: 'SCHEDULE_INTERVIEW' });
        actions.push({ label: 'Reject', action: 'REJECT' });
      } else if (column === ATS_CONSTANTS.COLUMNS.IN_CONSIDERATION) {
        const statuses = selectedCandidatesList.map((cand) => cand.interviewDetails?.status || ATS_CONSTANTS.STATUS.SCHEDULED);

        const allCompleted = statuses.every(s => s === ATS_CONSTANTS.STATUS.COMPLETED);
        const anyCancelled = statuses.some(s => s === ATS_CONSTANTS.STATUS.CANCELLED);
        const allReschedulable = statuses.every(s =>
          s === ATS_CONSTANTS.STATUS.SCHEDULED ||
          s === ATS_CONSTANTS.STATUS.RESCHEDULED ||
          s === ATS_CONSTANTS.STATUS.NO_SHOW
        );

        if (allCompleted) {
          actions.push({ label: 'Generate Offer', action: 'GENERATE_OFFER' });
        } else if (allReschedulable && !anyCancelled) {
          actions.push({ label: 'Reschedule', action: 'RESCHEDULE' });
        }

        actions.push({ label: 'Reject', action: 'REJECT' });
      }
      return actions;
    } else {
      return [{ label: 'Reject', action: 'REJECT' }];
    }
  };

  return {
    getBulkActions,
  };
};
